const NAME = "WORKS_AND_TASKS_SETTINGS";

export default NAME;
